import { Select } from '~/eds/src/components/Select/Select';
import { Option } from '~/eds/src/types/Option';

interface Props {
  options: Option<string>[];
  value: Option<string>[];
  disabled?: boolean;
  onChange: (options: Option<string>[]) => void;
  onAddOption: (newOption: Option<string>) => void;
}

export const DropdownOptionsSelect = ({
  disabled = false,
  options: initialOptions,
  value,
  onChange,
  onAddOption,
}: Props) => {
  return (
    <Select<string, true>
      isMulti
      disabled={disabled}
      name="dropdown-options-select"
      options={initialOptions.map((option) => ({
        label: option.label,
        value: option.value,
      }))}
      value={value.map((option) => option.value)}
      width="100%"
      onChange={(optionStrings) => {
        const options = optionStrings?.map((option) => ({
          label: option,
          value: option,
        }));
        onChange(options ?? []);
      }}
      onAddOption={(newOption) => onAddOption(newOption)}
    />
  );
};
